import { FCX } from "@datassential/platform-ui-lib";
import HistoricTrendChartInfoItem from "./HtChartInfoItem";
import PptExportButton from "@components/AsideButtons/PptExportButton";
import AsideButtons from "@components/AsideButtons/AsideButtons";
import { useTrendContext } from "@pages/Trend/TrendContext";
import { useMetric } from "@core/CommonDataContext";
import { useHistoricTrendContext } from "./HtContext";
import { useMemo } from "react";
import cn from "classnames";
import { components } from "@api/api";
import { useSelectAmongContext } from "@vms/SelectAmong/SelectAmongContext";

type ExportPayload = components['schemas']['FlavorTracker.Entities.DTO.Export.TrendPagePptExportRequest'];

const HistoricTrendChartInfo: FCX = () => {
	const { selectedMetric } = useTrendContext();

	const {
		selectedItems,
		data,
	} = useHistoricTrendContext();

	const { amongPayload } = useSelectAmongContext();

	const payload = useMemo(
		(): ExportPayload => ({
			...amongPayload,
			metric: selectedMetric as ExportPayload['metric'],
			keywordsIds: selectedItems.map(i => i.id ?? 0),
		}),
		[amongPayload, selectedItems, selectedMetric]
	);

	const metric = useMetric(selectedMetric);

	const chartInfoItems = useMemo(() => {
		return selectedItems.length
			? selectedItems.map((item, index) => {
				if (!item.id) return null
				const extendedItem = data[item.id]

				return (
					<HistoricTrendChartInfoItem
						key={item.id}
						item={extendedItem}
						color={item.color}
						testId={`blockHistoricTrendItem_${index}`}
					/>
				)
			})
			: <div className={
					cn(
						"HtChartInfo__list-empty",
						"appears",
						"fast"
					)
				}
				data-testid="textHistoricTrendEmpty"
			>
				Please select items to see the chart!
			</div>;
	}, [selectedItems, data]);

	return (
		<>
			{selectedItems.length > 0 && (
				<AsideButtons>
					<PptExportButton
						url="/api/export/GetTrendPagePpt"
						payload={payload}
						className="HtChartInfo__ppt-export"
						testId="buttonHistoricTrendPptExport"
					/>
				</AsideButtons>
			)}
			<div className="HtChartInfo">
				<div className="HtChartInfo__header">
					<span
						className="HtChartInfo__header-title"
						data-testid="textHistoricTrendMetricName"
					>
						{metric?.name?.toUpperCase() ?? ''}
					</span>
					<span
						className="HtChartInfo__header-change"
						data-testid="textHistoricTrendYrChange"
					>
						2 Yr Change
					</span>
				</div>
				<div
					className="HtChartInfo__list"
					data-testid="blockHistoricTrendList"
				>
					{chartInfoItems}
				</div>
			</div>
		</>
	);
};

export default HistoricTrendChartInfo;